import { Suspense, lazy } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Box } from '@chakra-ui/react'
import { useAuth } from './hooks/useAuth'
import Layout from './components/Layout'
const HomePage = lazy(() => import('./pages/HomePage'))
const WorkflowsPage = lazy(() => import('./pages/WorkflowsPage'))
const StepDetailPage = lazy(() => import('./pages/StepDetailPage'))
const WorkflowTypesPage = lazy(() => import('./pages/WorkflowTypesPage'))
const SamplingUnifiedPage = lazy(() => import('./pages/SamplingUnifiedPage'))
const OperatorsPage = lazy(() => import('./pages/OperatorsPageSimple'))
const CustomersPage = lazy(() => import('./pages/CustomersPage'))
const UsersPage = lazy(() => import('./pages/UsersPage'))
const SettingsPage = lazy(() => import('./pages/SettingsPage'))
const LoginPage = lazy(() => import('./pages/LoginPage'))
import LoadingSpinner from './components/LoadingSpinner'

function App() {
  const { isAuthenticated, loading } = useAuth()

  if (loading) {
    return <LoadingSpinner message="系統初始化中..." />
  }

  return (
    <Box minH="100vh">
      <Suspense fallback={<LoadingSpinner message="載入頁面中..." />}>
        <Routes>
          <Route
            path="/login"
            element={
              isAuthenticated ? <Navigate to="/" replace /> : <LoginPage />
            }
          />
          <Route
            path="/"
            element={
              isAuthenticated ? <Layout /> : <Navigate to="/login" replace />
            }
          >
            <Route index element={<HomePage />} />
            <Route path="workflows" element={<WorkflowsPage />} />
            <Route path="workflows/:id" element={<WorkflowsPage />} />
            <Route path="workflows/:workflowId/steps/:stepId" element={<StepDetailPage />} />
            <Route path="workflow-types" element={<WorkflowTypesPage />} />
            <Route path="operators" element={<OperatorsPage />} />
            <Route path="sampling" element={<SamplingUnifiedPage />} />
            <Route path="customers" element={<CustomersPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        </Routes>
      </Suspense>
    </Box>
  )
}

export default App